module.exports = __webpack_public_path__ + "static/media/django.8e9f55d4.png";